import React, { useState } from 'react';
export function Line(props) {
    const { className, fill = 'none', hoverEffect = true, id, onClick, path, stroke = 'white', strokeWidth = 1, } = props;
    const [hovered, setHovered] = useState(false);
    const mouseOverHandler = () => {
        setHovered(true);
    };
    const mouseOutHandler = () => {
        setHovered(false);
    };
    return (React.createElement("path", { d: path, fill: fill, stroke: stroke, style: { cursor: onClick ? 'pointer' : 'default' }, strokeWidth: hovered && hoverEffect && onClick ? strokeWidth + 2 : strokeWidth, className: className, "data-cy": props['data-cy'], id: id, onClick: onClick, onMouseEnter: mouseOverHandler, onMouseLeave: mouseOutHandler }));
}
//# sourceMappingURL=Line.js.map